import { axiosInstance } from "../axios";

export const fileApi = {
  upload: async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return await axiosInstance.post("/files/create", formData);
  },
};
